export default process.env.appCode;
